import { render, staticRenderFns } from "./infoConfirm.vue?vue&type=template&id=16be2f08&scoped=true&"
import script from "./infoConfirm.vue?vue&type=script&lang=ts&"
export * from "./infoConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./infoConfirm.vue?vue&type=style&index=0&id=16be2f08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16be2f08",
  null
  
)

export default component.exports